package fr.manyverse.app.presentation.components.modules.gm_timer

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Slider
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import fr.manyverse.app.presentation.components.CheckboxRow
import fr.manyverse.app.presentation.components.clearFocusOnTap
import fr.manyverse.app.presentation.components.modules.timer.formatSecondsToHhMmSs
import fr.manyverse.app.presentation.components.modules.timer.parseHhMmSs
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.cancel
import manyverse.shared.generated.resources.timer_duration_hint
import manyverse.shared.generated.resources.timer_duration_label
import manyverse.shared.generated.resources.timer_gm_continue_after_end
import manyverse.shared.generated.resources.timer_gm_launch_title
import manyverse.shared.generated.resources.timer_launch
import org.jetbrains.compose.resources.stringResource

@Composable
fun GmTimerLaunchDialog(
    showDialog: Boolean,
    onDismiss: () -> Unit,
    onConfirm: (durationSeconds: Int, continueAfterEnd: Boolean) -> Unit,
    modifier: Modifier = Modifier
) {
    var durationText by remember { mutableStateOf("00:05:00") }
    var sliderMinutes by remember { mutableFloatStateOf(5f) }
    var durationSeconds by remember { mutableIntStateOf(300) }
    var continueAfterEnd by remember { mutableStateOf(false) }

    LaunchedEffect(showDialog) {
        if (showDialog) continueAfterEnd = false
    }

    val canSubmit = durationSeconds in 1..28800

    if (showDialog) {
        AlertDialog(
            properties = DialogProperties(dismissOnBackPress = false, dismissOnClickOutside = false),
            onDismissRequest = onDismiss,
            title = { Text(stringResource(Res.string.timer_gm_launch_title)) },
            text = {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    Column {
                        Text(
                            text = stringResource(Res.string.timer_duration_label),
                            style = MaterialTheme.typography.labelMedium
                        )

                        OutlinedTextField(
                            value = durationText,
                            onValueChange = { newText ->
                                durationText = newText
                                val parsed = parseHhMmSs(newText)
                                if (parsed != null && parsed in 1..28800) {
                                    durationSeconds = parsed
                                    sliderMinutes = (parsed / 60f).coerceIn(1f, 10f)
                                } else if (parsed != null) {
                                    durationSeconds = parsed
                                    sliderMinutes = 10f
                                }
                            },
                            placeholder = { Text(stringResource(Res.string.timer_duration_hint)) },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth().padding(top = 8.dp)
                        )

                        Slider(
                            value = sliderMinutes,
                            onValueChange = { value ->
                                sliderMinutes = value
                                val newSeconds = (value * 60).toInt()
                                durationSeconds = newSeconds
                                durationText = formatSecondsToHhMmSs(newSeconds)
                            },
                            valueRange = 1f..10f,
                            steps = 8,
                            modifier = Modifier.fillMaxWidth()
                        )

                        Text(
                            text = "${sliderMinutes.toInt()} min",
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }

                    CheckboxRow(
                        label = stringResource(Res.string.timer_gm_continue_after_end),
                        checked = continueAfterEnd,
                        onCheckedChange = { continueAfterEnd = it }
                    )
                }
            },
            confirmButton = {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TextButton(onClick = onDismiss) {
                        Text(stringResource(Res.string.cancel))
                    }
                    Button(
                        onClick = { onConfirm(durationSeconds, continueAfterEnd) },
                        enabled = canSubmit
                    ) {
                        Text(stringResource(Res.string.timer_launch))
                    }
                }
            },
            modifier = modifier.clearFocusOnTap()
        )
    }
}

